/* eslint-disable no-plusplus */
import { useEffect, useRef } from 'react';

import { useGlobalStore } from '@cccom/config/global-store';
import { log } from '@cccom/shared/logging';

const secretCode = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
];

export function useDevModeShortcut(enableDevMode = true) {
  const devMode = useGlobalStore((s) => s.devMode);
  const setDevMode = useGlobalStore((s) => s.setDevMode);
  const secretIndex = useRef(0);

  useEffect(() => {
    if (!enableDevMode) return () => null;

    function handleKeyDown(e: KeyboardEvent) {
      if (devMode && e.key === 'Escape') {
        setDevMode(false);
        log.info('Dev mode: DISABLED');
        secretIndex.current = 0;
        return;
      }

      if (e.key === secretCode[secretIndex.current]) {
        secretIndex.current++;
        if (secretIndex.current === secretCode.length) {
          setDevMode(!devMode);
          log.info(`Dev mode: ${!devMode ? 'ENABLED' : 'DISABLED'}`);
          secretIndex.current = 0;
        }
      } else {
        secretIndex.current = 0;
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [devMode, enableDevMode, setDevMode]);

  return { devMode, setDevMode };
}
